import React from "react";
import styles from "../KpiForm.module.sass";
import { Dropdown, MultiSelectionInput } from "colbi_web_ui/lib/components/inputs";
import { SovosIcon } from "mosaic-react";
import { HighlightOff } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const ConfigsTab = ({ Config, Classifiers, handleConfigsChange, handleChange, kpisList }) => {
    const { i18n, locale: actualLocale } = useGlobalValue();
    const { level, appliesTo, appliesToVersion } = Classifiers || {};

    const parsedConfig = JSON.parse(Config || "[]");
    const usedAppliesTo = (parsedConfig || []).map(({ FileType }) => FileType);
    const availableAppliesTo = (appliesTo || []).filter(
        ({ id }) => !(usedAppliesTo || []).includes(id),
    );

    const ruleConfigurations = buildConfigsDataContainer(parsedConfig, appliesTo);

    function isToShowAppliesTo(appliesToValueArray) {
        return !!(appliesToValueArray && appliesToValueArray.length);
    }

    function buildConfigsDataContainer(kpiConfigs, appliesToArray) {
        const hasKpiConfigs = !!(kpiConfigs && kpiConfigs.length);

        return (
            hasKpiConfigs &&
            kpiConfigs.map((elem, index) => {
                const { FileType, AppliesToVersion, RuleExecutionLevel, Dependencies } = elem || {};
                const hasAppliesToDataTypes =
                    appliesToArray && appliesToArray.length
                        ? appliesToArray.reduce((acc, { config }) => {
                            const appliesToParsedConfig = JSON.parse(config);
                            if (config && appliesToParsedConfig[FileType]) {
                                const parsedDataTypes = JSON.parse(
                                    appliesToParsedConfig[FileType],
                                )["dataTypes"];
                                const subTypes = Object.keys(parsedDataTypes) || [];
                                subTypes &&
                                    subTypes.length &&
                                    subTypes.forEach((label) => {
                                        const defaultLocale = Object.keys(parsedDataTypes[label]);
                                        acc.push({
                                            id: label,
                                            name:
                                                parsedDataTypes[label][actualLocale] ||
                                                (defaultLocale && defaultLocale.length
                                                    ? parsedDataTypes[label][defaultLocale[0]]
                                                    : "N/A"),
                                        });
                                    });
                            }
                            return acc;
                        }, [])
                        : [];

                return (
                    <div key={index} className={styles["kpi-entry"]}>
                        <div className={styles["config-remove-button-container"]}>
                            <div className={styles["remove-button-container"]}>
                                <button
                                    type="button"
                                    className={styles["remove-button"]}
                                    onClick={(e) => {
                                        kpiConfigs.splice(index, 1);
                                        handleChange(e, "Config", JSON.stringify(kpiConfigs));
                                    }}
                                >
                                    <SovosIcon>
                                        <HighlightOff />
                                    </SovosIcon>
                                </button>
                            </div>
                        </div>
                        <div className={styles["flex"]}>
                            <div className={styles["input-field"]}>
                                <h5 className={styles["label"]}>{i18n`Applies To`}</h5>
                                <Dropdown
                                    value={
                                        FileType && appliesTo.length
                                            ? appliesTo.find(({ id }) => id === FileType) ||
                                            appliesTo[0]
                                            : null
                                    }
                                    useI18n={false}
                                    options={availableAppliesTo || []}
                                    placeholder={""}
                                    className={styles["dropdown"]}
                                    filter
                                    onChange={(e) => {
                                        handleConfigsChange(
                                            e,
                                            "FileType",
                                            e.target.value.id,
                                            index,
                                            kpiConfigs,
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className={styles["flex"]}>
                            {isToShowAppliesTo(hasAppliesToDataTypes) && (
                                <div className={styles["input-field"]}>
                                    <MultiSelectionInput
                                        className={styles["input"]}
                                        name={i18n`Applies to Version`}
                                        value={(typeof AppliesToVersion === "string"
                                            ? JSON.parse(AppliesToVersion || "[]")
                                            : AppliesToVersion || []
                                        )
                                            .map((type) => type)
                                            .filter((p) => p)}
                                        placeholder={i18n`Select applies to version`}
                                        options={
                                            appliesToVersion && appliesToVersion.length
                                                ? appliesToVersion.map(({ id, name }) => ({
                                                    id,
                                                    name: name,
                                                }))
                                                : []
                                        }
                                        onChange={(e) => {
                                            const appliesToVersionValue = e.target.value.length
                                                ? e.target.value
                                                : null;
                                            handleConfigsChange(
                                                e,
                                                "AppliesToVersion",
                                                appliesToVersionValue,
                                                index,
                                                kpiConfigs,
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className={styles["input-field"]}>
                            <h5 className={styles["label"]}>{i18n`Execute On`}</h5>
                            <Dropdown
                                value={
                                    RuleExecutionLevel && level.length
                                        ? level.find(({ id }) => id === RuleExecutionLevel)
                                        : null
                                }
                                placeholder={""}
                                options={level || []}
                                className={styles["dropdown"]}
                                filter
                                onChange={(e) => {
                                    handleConfigsChange(
                                        e,
                                        "RuleExecutionLevel",
                                        e.target.value.id,
                                        index,
                                        kpiConfigs,
                                    );
                                }}
                            />
                        </div>
                        <div className={styles["flex"]}>
                            <div className={styles["input-field"]}>
                                <MultiSelectionInput
                                    className={styles["input"]}
                                    name={i18n`Kpi Dependencies`}
                                    value={(typeof Dependencies === "string"
                                        ? JSON.parse(Dependencies || "[]")
                                        : Dependencies || []
                                    )
                                        .map((type) => type)
                                        .filter((p) => p)}
                                    placeholder={i18n`Select Kpi Dependencies`}
                                    options={
                                        kpisList?.length
                                            ? kpisList.map(({ id, KpiID }) => {
                                                return { id, name: KpiID };
                                            })
                                            : []
                                    }
                                    onChange={(e) => {
                                        const appliesToVersionValue = e.target.value.length
                                            ? e.target.value
                                            : null;
                                        handleConfigsChange(
                                            e,
                                            "Dependencies",
                                            appliesToVersionValue,
                                            index,
                                            kpiConfigs,
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );
            })
        );
    }

    function buildConfigsContainer(parsedConfig) {
        const defaultObj = {
            FileType: "",
            AppliesToVersion: null,
            RuleExecutionLevel: "",
        };
        return (
            <div>
                <div className={styles["flex"]}>
                    <div className={styles["input-field"]}>
                        <div>
                            {(parsedConfig || []).length ? (
                                ruleConfigurations
                            ) : (
                                <small>{i18n`No configurations assigned`}</small>
                            )}
                        </div>
                        <div>
                            <button
                                className={styles["add-button"]}
                                type="button"
                                onClick={(e) => {
                                    handleChange(
                                        e,
                                        "Config",
                                        JSON.stringify([
                                            ...(parsedConfig || []),
                                            { ...defaultObj },
                                        ]),
                                    );
                                }}
                            >
                                {<small>{i18n`[+] Add new Configuration`}</small>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className={styles["group-content"]}>{buildConfigsContainer(parsedConfig)}</div>
        </div>
    );
};

export default ConfigsTab;
